import { render, staticRenderFns } from "./RptInterdisciplinaryProfile.vue?vue&type=template&id=8209d512&scoped=true&"
import script from "./RptInterdisciplinaryProfile.vue?vue&type=script&lang=js&"
export * from "./RptInterdisciplinaryProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8209d512",
  null
  
)

export default component.exports